var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBreadcrumbSeperator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 48,
    viewBox: "0 0 9 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.01136 14.7273L2.38636 35.625H0.545455L6.17045 14.7273H8.01136Z",
    fill: "#52697A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreadcrumbSeperator);
export default __webpack_public_path__ + "static/media/breadcrumb-seperator.1397c4979d782176048897d5c08910dd.svg";
export { ForwardRef as ReactComponent };